import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FileCards from "./FileCards";
import NewFilesList from "./NewFilesList";

const FileUploadModal = ({ open, handleClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={open}
      onHide={handleClose}
      className="d-flex">
      <Modal.Header className="d-flex" style={{ minWidth: 500 }}>
        <Modal.Title>{t('fileUpload')}</Modal.Title>
        <button
          className="btn btn-sm btn-primary align-self-end"
          type="submit"
          onClick={handleClose}>
          X
        </button>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{ padding: 12 }}
          className='h6'>
          {t('files')}
        </div>
        <FileCards />

        <div
          style={{ padding: '24px 0px 8px 12px' }}
          className='h6'>
          {t('uploadNewFiles')}
        </div>
        <NewFilesList />
      </Modal.Body>
    </Modal>
  );
};

export default FileUploadModal;
